<template>
  <div class="table-wrapper">
      <Table v-bind="table" class="io-table" style="border:1px solid #eee;" :height="height" :key="height">
      </Table>
  </div>
</template>

<script>
import {getPointPage} from '@/api/memberManagement'
import Table from '@/components/page/Table.vue'
export default {
  components: {
    Table
  },
  props: {
    userId: [Number, String]
  },
  data () {
    return {
      table: {
        selection: false, // 是否开启选择框
        hiddenOperate: true,
        tableInfo: [{
          key: 'num',
          name: '序号',
          width: 80
        }, {
          key: 'date',
          name: '时间'
        }, {
          key: 'point',
          name: '积分'
        }],
        tableData: []
      },
      height: '300'
    }
  },
  computed: {
    params () {
      return {
        size: 1000,
        current: 1,
        userId: this.userId
      }
    }
  },
  created () {
    this.$watch('userId', (userId) => {
      this.getPointPage({...this.params, userId})
    }, {
      immediate: true
    })
  },
  mounted () {
    const screenHeight = parseInt(window.innerHeight * 0.4)
    this.T = setTimeout(() => {
      const dom = document.querySelector('.io-table')
      const tableBody = dom.querySelector('.el-table__body')
      this.height = String(tableBody.clientHeight < screenHeight ? 300 : screenHeight)
      clearTimeout(this.T)
    }, 180)
  },
  methods: {
    getPointPage (moduleId) {
      getPointPage(moduleId).then(res => {
        const {success, data} = res
        if (success) {
          const {records} = data

          records.forEach((item, idx) => {
            item.num = idx + 1
          })
          console.log('records', records)
          this.$set(this.table, 'tableData', records)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.table-wrapper{
    max-height: 40vh;
    overflow:hidden;
    margin-bottom: 30px;
}
</style>